<template>
  <CreatePlan
    v-if="plan_page == 'new'"
    :key="componentKey + 999"
    :from-expand="true"
    :full-screen="true"
    class="p-12"
    :company="$store.state.ui.currentCompany"
    @done="handleDone('create')"
    @error="handleError"
    @cancel="handleClose" />
  <EditPlan
    v-if="plan_page == 'edit' && plan"
    :key="componentKey"
    :from-expand="true"
    :full-screen="true"
    class="p-12"
    :company="$store.state.ui.currentCompany"
    :plan="plan"
    @done="handleDone('edit')"
    @error="handleError"
    @cancel="handleClose" />
</template>

<script>
import dataService from "@/services/data.service"
import EditPlan from "@/components/forms/EditPlan.vue"
import CreatePlan from "@/components/forms/CreatePlan"
export default {
  name: "PlanPageContainer",

  components: {
    EditPlan,
    CreatePlan
  },
  data() {
    return {
      plan: null,
      plan_page: null,
      componentKey: 1
    }
  },

  activated() {
    this.componentKey += 1
    const plan_id = this.$route.params.pid
    if (plan_id == "new") {
      this.plan_page = "new"
    } else {
      this.plan_page = "edit"
      dataService.getPlan(plan_id).then((res) => {
        this.plan = res.data
      })
    }
  },

  methods: {
    handleDone(type) {
      this.$router.go(-1)
      this.$toast.open({
        message: this.$t("Plan successfully") + ` ${type == "edit" ? this.$t("updated") : this.$t("created")}`,
        position: "top",
        type: "success",
        duration: 3000
      })
    },
    handleError() {
      this.$router.go(-1)
    },
    handleClose() {
      this.$router.go(-1)
    }
  }
}
</script>
